var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"send",on:{"click":function($event){$event.stopPropagation();return _vm.$refs.agreeDia.openDia()}}},[_c('span',[_vm._v("发送")]),_c('agreeDia',{ref:"agreeDia"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }